import React, {useRef, useState} from 'react'
import {AlertDialog} from '../../../components/Dialog/Dialog'
import {FormikValues, useFormikContext} from 'formik'

interface InputImageProps {
  file: File | null
  setFile: (file: File | null) => void
  currentImage: string
}

const InputImage: React.FC<InputImageProps> = ({file, setFile, currentImage}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [showError, setShowError] = useState(false)
  const {setFieldValue, setFieldTouched} = useFormikContext<FormikValues>()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null
    if (!selectedFile) return

    if (selectedFile.size > 2 * 1024 * 1024) {
      setShowError(true)
      return
    }
    setFieldValue('imagen', 'selected')
    setFieldTouched('imagen', true)
    setFile(selectedFile)
  }

  const handleClick = () => {
    inputRef.current?.click()
  }

  return (
    <>
      <input
        type='file'
        id='image-product'
        accept='image/*'
        hidden
        ref={inputRef}
        onChange={handleFileChange}
      />
      {file || currentImage ? (
        <>
          <div
            className='border border-primary border-dashed rounded-4 p-4 bg-primary bg-opacity-10'
            style={{height: '200px'}}
          >
            <img
              src={file ? URL.createObjectURL(file) : currentImage}
              alt='Preview'
              className='h-100 mx-auto d-block'
              style={{objectFit: 'contain'}}
            />
          </div>
          <div className='mt-2 d-flex align-items-center'>
            <span className='fw-bold fs-6 me-2'>{file ? file.name : ''} </span>
            <i
              className='ki-duotone ki-arrows-circle fs-2x text-primary fw-bold cursor-pointer'
              title='Cambiar imagen'
              onClick={handleClick}
            >
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
            {file && (
              <i
                className='ki-duotone ki-cross-circle fw-bold cursor-pointer fs-2x text-danger ms-2'
                title='Eliminar imagen'
                onClick={() => {
                  setFile(null)
                  setFieldValue('imagen', currentImage ? 'selected' : '')
                }}
              >
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
            )}
          </div>
        </>
      ) : (
        <div
          className='border border-primary border-dashed rounded-4 d-flex align-items-center justify-content-center p-4 cursor-pointer text-primary bg-primary bg-opacity-10'
          style={{height: '200px'}}
          onClick={handleClick}
        >
          <div className='text-center'>
            <i className='fas fa-upload fs-2x text-primary'></i>
            <p className='fs-6'>Selecciona la imagen aquí (Máximo 2MB)</p>
          </div>
        </div>
      )}

      {!!showError && (
        <AlertDialog
          message='El tamaño del archivo excede el límite de 2MB.'
          show={showError}
          onConfirm={() => setShowError(false)}
          title='Error'
        />
      )}
    </>
  )
}

export default InputImage
